<template>
  <div>
    <Head />

    <nav class="breadcrumb_box" aria-label="breadcrumb" v-if="CategoryData">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">{{ $t('首頁') }}</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ CategoryData.Category.CategoryName }}</li>
      </ol>
    </nav>
    <div class="wrapper list_1" v-if="CategoryData && CategoryData.Category.Type == 0">
      <svg class="bg"></svg>
      <!-- 最新消息 -->
      <section class="">
        <div class="container">
          <div class="list_box">
            <div class="title_box">
              <h1>{{ CategoryData.Category.CategoryName }}</h1>
            </div>
            <ul class="list">
              <li v-for="Post in Posts" :key="Post.PId">
                <a href="javascript:void(0)" class="text" @click="gotoPost(Post)">
                  <p class="time">{{ Post.PublicStartTime | timeString("YYYY-MM-DD") }}</p>
                  <p>{{ Post.Title }}</p>
                </a>
              </li>
            </ul>
          </div>
          <paginate :no-li-surround="false" :page-count="pageAll" :page-range="3" :margin-pages="1"
            :click-handler="loadList" :prev-text="'«'" :next-text="'»'" :prev-link-class="'page-link'"
            :next-link-class="'page-link'" :container-class="'pagination'" :page-class="'page-item'"
            :page-link-class="'page-link'" :active-class="'active'" :hide-prev-next="false" v-if="pageAll > 1">
          </paginate>
        </div>
      </section>
    </div><!-- wrapper -->

    <div class="wrapper list_1 list_2" v-if="CategoryData && CategoryData.Category.Type == 1">
      <svg class="bg"></svg>
      <!-- 圖文列表 -->
      <section class="">
        <div class="container">
          <div class="list_box">
            <div class="title_box">
              <h1>{{ CategoryData.Category.CategoryName }}</h1>
            </div>
            <ul class="list">
              <li v-for="Post in Posts" :key="Post.PId">
                <a href="javascript:void(0)" class="text" @click="gotoPost(Post)">
                  <div class="img_box">
                    <img :src="CategoryData.SiteUrl + Post.Image" alt="" v-if="Post.Image" />
                    <img src="img/img_7.png" alt="" v-if="!Post.Image">
                  </div>
                  <p class="time">{{ Post.PublicStartTime | timeString("YYYY-MM-DD") }}</p>
                  <p>{{ Post.Title }}</p>
                </a>
              </li>
            </ul>
          </div>
          <paginate :no-li-surround="false" :page-count="pageAll" :page-range="3" :margin-pages="1"
            :click-handler="loadList" :prev-text="'«'" :next-text="'»'" :prev-link-class="'page-link'"
            :next-link-class="'page-link'" :container-class="'pagination'" :page-class="'page-item'"
            :page-link-class="'page-link'" :active-class="'active'" :hide-prev-next="false" v-if="pageAll > 1">
          </paginate>
        </div>
      </section>
    </div><!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

const messages = {
  zh_tw: {
    "首頁": "首頁",
  },
  en: {
    "首頁": "Home Page",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "Category",
  i18n,
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      CategoryData: null,
      Posts: null,
      local: "zh_tw",
      pageAll: 0,
      perPage: 10,
      QAIndex: -1,
    };
  },
  beforeRouteUpdate(to, from, next) {
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/Html/Category",
        {
          params: { CId: to.params.CId, lang: $cookies.get("dormitory_site_lang") },
        }
      )
      .then((response) => {
        this.CategoryData = response.data;
        this.loadList(1);
      })
      .catch((error) => {
        console.log(error);
      });
    next();
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/Html/Category",
        {
          params: { CId: this.$route.params.CId, lang: $cookies.get("dormitory_site_lang") },
        }
      )
      .then((response) => {
        this.CategoryData = response.data;
        this.loadList(1);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("dormitory_site_lang")) {
      i18n.locale = $cookies.get("dormitory_site_lang");
      this.local = $cookies.get("dormitory_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    loadList: function (page) {
      var that = this;
      $.ajax({
        url:
          this.$store.state.src +
          this.$store.state.subDirectory +
          "/Html/PostList",
        type: "post",
        data: {
          CId: this.$route.params.CId,
          page: page,
          perPage: that.perPage,
          lang: $cookies.get("dormitory_site_lang"),
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.status == 1) {
            this.QAIndex = -1;
            that.Posts = res.Posts;
            that.perPage = res.perPage;
            that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
            document.body.scrollTop = 0;
          }
        },
      });
    },
    gotoPost(Post) {
      if (Post.Type == 1) {
        if (Post.Blank) {
          window.open(Post.Url, "_blank");
        } else {
          location.href = Post.Url;
        }
      } else {
        this.$router.push({
          name: "Post",
          params: { PId: Post.PId, CId: this.CategoryData.Category.CId },
        });
      }
    },
  },
};
</script>
